import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { actionTracking } from '../../store/common/actions';

function CheckLoanConsent() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    dispatch(
      actionTracking({
        url: window.location.href,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (!location.state?.requestId) {
      navigate('/');
    }
  }, [location.state?.requestId, navigate]);

  return (
    <div className="bg-white p-5">
      <p className="text-xs text-gray1 mb-2">閣下登入前，務請仔細閱讀本聲明：</p>
      <div className="border rounded-md border-primary2 p-4 text-xs text-gray1">
        <p className="mb-2">私隱政策及收集個人資料聲明</p>
        <p className="mb-2">本聲明適用於Cashing Pro Limited（下稱「Cashing Pro」及「本公司」）。</p>
        <p className="mb-2">在本聲明中，「資料當事人」、「閣下」或「客戶」一詞應涵蓋本公司網站之訪客﹑Cashing Pro LiveChat的使用者﹑貸款申請人及貸款客戶。另外，在本聲明中，「集團公司」一詞是指本公司之本地及海外的集團公司（例如同一控股的母公司或子公司等）。</p>
        <p className="mb-2">
          本聲明之內容適用於所有資料當事人及為資料當事人不時與Cashing Pro所訂立或可能會訂立的貸款協議及／或任何協議或安排的條款及細則的一部分。若本聲明與相關的協議或安排有任何不一致或歧異之處，所有有關保障資料當事人的個人資料以本聲明為準。
        </p>
        <p className="my-6">私隱政策聲明</p>
        <p>1. 本公司的私隱政策及承諾</p>
        <p>Cashing Pro 重視閣下的私隱，Cashing Pro承諾並確保本公司的僱員嚴謹遵守及執行個人資料（私隱）條例（香港法例第486章）（下稱「該條例」）下的保障資料原則，以及由香港持牌放債人公會就該條例而頒布的指引，以全力保護其閣下的個人資料的私隱不會遭到外洩。本聲明目的為了協助閣下明白Cashing Pro有關個人資料的私隱政策及實務。</p>
        <p className="mt-4">2. 個人資料的收集種類</p>
        <p className="mb-3">個人資料指任何與個人有關的資料，而從該資料可直接或間接地確定有關個人的身分。Cashing Pro 可能收集（包括但不限於）以下資料，而其可能不時成為個人資料：</p>
        <p>2.1. 姓名；</p>
        <p>2.2. 年齡；</p>
        <p>2.3. 性別；</p>
        <p>2.4. 電話號碼及電訊商 ;</p>
        <p>2.5. 電郵地址；</p>
        <p>2.6. 身份證號碼或護照號碼；</p>
        <p>2.7. 國籍或居留身分；</p>
        <p>2.8. 出生日期；</p>
        <p>2.9. 個人財務狀況；</p>
        <p>2.10. 貸款目的;</p>
        <p>2.11. 收入或財產資料；</p>
        <p>2.12. 教育程度；</p>
        <p>2.13. 就業資料；</p>
        <p>2.14. 居住資料；</p>
        <p>2.15. 銀行戶口或儲值支付工具戶口之詳情；</p>
        <p>2.16. 對任何貸款產品的個人偏好；</p>
        <p>2.17. 閣下與Cashing Pro 的對話內容；</p>
        <p>2.18. 有關閣下瀏覽及使用Cashing Pro 網站及Cashing Pro LiveChat的對話資料內容；及</p>
        <p>2.19. 有關閣下瀏覽及使用Cashing Pro網站的資料。</p>

        <p className="my-4">3. 使用個人資料的目的</p>
        <p>3.1. 為使Cashing Pro更有效地提供服務，客戶在開立或延續貸款戶口、建立或延續信貸或接受其他財務服務時，需要不時向Cashing Pro提供相關個人資料。</p>
        <p>3.2. 若未能提供該等個人資料，可能會導致Cashing Pro無法開立或延續貸款戶口，或建立或延續信貸，或向客戶提供其他財務服務。</p>
        <p>3.3. Cashing Pro在正常業務運作中，例如，當客戶以口頭或書面形式（包括但不限於電子郵件、郵寄信件）與Cashing Pro溝通時，亦會透過電子紀錄或Cashing Pro的電話錄音系統（視屬何種情況而定）向客戶收集個人資料。</p>
        <p>3.4. 為使Cashing Pro更有效地提供服務，並在得到客戶同意的情況下，本公司可能從信貸參考機構中取得客戶的個人資料（客戶可要求Cashing Pro提供該機構之聯絡資料）。Cashing Pro亦會透過不同途徑，例如公共搜尋器﹑公共登記冊﹑公共名冊或客戶已授權設定為公開分享的任何社交媒體等公共領域查閱及取得客戶的個人資料。Cashing Pro亦會透過資料當事人的網頁瀏覽器取得資料當事人的裝置資料。</p>
        <p>3.5. 資料當事人的個人資料可被用於下列用途：</p>
        <p>a. 處理和批核貸款申請以及向客戶提供貸款服務所涉及之日常運作；</p>
        <p>b. 在資料當事人首次或再次申請貸款或申請續借貸款時進行信貸調查：</p>
        <p>i.Cashing Pro有權查詢資料當事人於信貸資料庫內由信貸資料庫其他會員（即信貸資料提供者）提供的信貸資料，信貸資料包括資料當事人之申請金額、期數、批核、拒絕、放款、逾期還款、拖欠、交追數、撇帳及現時尚欠本息的部份或全部資料，用作審批貸款申請及了解日後還款情況之用途；</p>
        <p>ii. 為了取得資料當事人的信貸評估，Cashing Pro同時亦可將資料當事人的貸款資料及日後還款狀況資料上傳至信貸資料庫，以便審批資料當事人的貸款申請，及／或向資料當事人提供相關的金融服務；</p>
        <p>iii. 資料當事人之上載資料，可為其他信貸資料庫的客戶、機構用作信用參考；</p>
        <p>c. 制定及維持Cashing Pro的信貸評分或與風險相關準則；</p>
        <p>d. 確保資料當事人可持續地維持可靠信用度以及良好聲譽;</p>
        <p>e. 不定期更新資料當事人的個人資料以協助Cashing Pro作信用檢查及追討債務;</p>
        <p>f. 設計為資料當事人使用的貸款服務或相關服務;</p>
        <p>g. 進行市場調查或內部分析以提供更優質貸款服務;</p>
        <p>h. 在資料當事人的同意下，直接促銷貸款相關服務; 及在以下第 9 段提及的直接促銷相關的其他事項；</p>
        <p>i. 計算Cashing Pro與資料當事人之間的欠款；</p>
        <p>j. 確保Cashing Pro與資料當事人的合約下的權利，包括向資料當事人收集尚未償還的欠款；</p>
        <p>k. 確保Cashing Pro及集團公司內的任何機構履行並遵守有關資料披露及使用的責任、規定或安排：</p>
        <p>i. 在目前或未來於香港特別行政區（下稱「香港」）境內或境外生效的對Cashing Pro及集團公司內的任何機構具法律約束力或適用的任何法律﹑規例﹑判詞﹑法庭命令﹑義務守則或制裁制度；</p>
        <p>ii. 在目前或未來於香港境內或境外生效的任何法律﹑監管﹑政府﹑稅務﹑執法或其他機關，或相關證券交易所﹑金融服務供應商的自律監管或行業機構或組織作出或頒布出的任何指引、指導、業務守則或要求；</p>
        <p>iii. Cashing Pro及集團公司內的任何機構因其位於或跟相關本地或外地的法律、監管、政府、稅務、執法或其他機關，或自律監管或行業組織或協會的司法管轄區有關的理財、商業、業務或其他利益或活動，而向該等本地或外地的法律、監管、政府、稅務、執法或其他機關，或金融服務供應商的自律監管或行業組織或協會承擔或被彼等施加的任何目前或將來的合約或其他承諾；</p>
        <p>l. 遵守及履行在Cashing Pro及集團公司內的任何機構內的資料及資訊共享及／或資料及資訊的任何其他使用，均依照符合制裁或預防或偵測清洗黑錢、恐怖分子融資及資金籌集或其他非法活動的制裁、防止或偵測方案就於Cashing Pro及集團公司內的任何機構的計劃而進行的任何責任、規定、政策、程序、措施或安排；</p>
        <p>m. 供Cashing Pro 全部或任何部份業務及／或資產的實際或潛在承讓人，或Cashing Pro對資料當事人的貸款／信貸設施的權利的參與人或附屬參與人衡量有關轉讓、參與或附屬參與所涉交易，和容許實際承讓人在經營業務或分配權利時使用此等資料；</p>
        <p>n. 比較資料當事人及其他人士就信貸審批﹑資料核證及製作或核實資料而提供的資料，不論是否為對該資料當事人採取行動的目的；</p>
        <p>o. 作為維持資料當事人的信貸記錄或其他記錄，不論資料當事人與本公司是否存在任何關係，以作現在或將來參考用；</p>
        <p>p. 管理﹑提升﹑維持及提供Cashing Pro LiveChat及處理或與資料當事人溝通其透過Cashing Pro LiveChat提出的任何查詢或要求；及</p>
        <p>q. 與上述用途有關的任何其他用途。</p>
        <p className="mt-3">4. 個人資料的可能承轉人類別</p>
        <p className="mb-2">Cashing Pro會對其持有的所有資料當事人資料予以保密，但Cashing Pro可能會把該等資料提供或轉移給下列各方以達至第3段中的目的：</p>
        <p>4.1. 確使信貸融通、貸款服務的建立、運作、維持或提供而向Cashing Pro或集團公司內的任何機構提供行政、郵寄、電訊、電話行銷、直銷代理人、資料服務、電腦、付款、數據處理、專業、諮詢收債或其他與Cashing Pro或集團公司內的任何機構（包括其員工、人員、代理商、承包商、服務提供商、專業顧問或第三方服務供應商）；</p>
        <p>4.2. 任何對Cashing Pro有保密責任及已承諾保密該等資料的其他人；</p>
        <p>4.3. Cashing Pro有責任或在其他情況下須向其作出「有關披露」的任何人士；而「有關披露」是指：對Cashing Pro具約束力或適用的任何法律的規定下的披露；或由任何政府、法律、執法機構、監管、稅務或其他機關，或財務服務供應商的自我監管或行業機構或組織所作出或頒布的Cashing Pro被預期遵守的任何指引或指導下及其所指的任何披露；或依據Cashing Pro與本地或外地法律、監管、政府、稅務、執法或其他機關，或財務服務供應商的自我監管或行業機構或組織之間的任何合約承諾或其他承諾的任何披露（以上可為於目前或未來在香港境內或境外生效者）；</p>
        <p>4.4. Cashing Pro集團公司內的任何機構；</p>
        <p>4.5. Cashing Pro在香港所搜集的個人資料或會被轉移至香港境內外。</p>
        <p className="mt-3">5. 個人資料的保安</p>
        <p>Cashing Pro的政策為因應資料的敏感程度及因擅自查閱所造成的損害程度，確保個人資料獲得適當程度的保護並全面遵守該條例下的規定（尤其是該條例下的第4保障資料原則），以防止資料被擅自查閱、處理或作其他用途。為達到適當程度的保安保護，Cashing Pro的一貫做法為透過提供保安的儲存設施，以及在資料存置設備實施保安措施，來限制對資料的實體接觸。Cashing Pro亦採取措施以確保查閱該等資料的人士具備良好操守、審慎態度及辦事能力。資料只會以保安的方式傳送。</p>
        <p className="my-3">6. 個人資料的準確性Cashing Pro的政策為確保由Cashing Pro收集及處理的所有個人資料均為準確並全面遵守該條例下的規定（尤其是該條例下的第2保障資料原則）。Cashing Pro實施適當的程序以定期核對及更新所有個人資料，以確保有關的資料就被使用或將被使用的目的而言屬準確。倘若Cashing Pro所持有的個人資料含有意見陳述，Cashing Pro會採取一切合理切實可行的步驟，以確保任何為支持有關意見陳述而獲引述的事實，均屬正確。</p>
        <p className="mb-3">7. 個人資料的收集</p>
        <p>7.1. 在收集個人資料的過程中，Cashing Pro會在資料當事人提交貸款申請表前向資料當事人提供「個人資料收集聲明」的連結，述明收集資料的目的、將獲轉交資料的人士的身分類別、查閱及改正資料的權利，以及其他有關資料。</p>
        <p>7.2. 有關Cashing Pro於網上收集個人資料，Cashing Pro會採納以下實務：</p>
        <p>7.2.1. 網上保安</p>
        <p>Cashing Pro會按照嚴格的保安及保密標準保障在網上提供給Cashing Pro的任何資料；並已採用加密技術在互聯網上傳輸敏感性資料，以保障個人的私隱。</p>
        <p>7.2.2.「Cookies」檔案</p>
        <p>「Cookies」檔案被設計成只可讓發出的網站讀取，但不能用作取得使用者的硬碟資料、電郵地址或收集使用者的敏感性資料。當資料當事人瀏覽Cashing Pro網站，與Cashing Pro LiveChat互動或點擊Cashing Pro的網上廣告時放置在資料當事人的裝置上的小段資料檔案，使網站伺服器能於稍後再從瀏覽器內讀取，這有助網站保存某些使用者的資料。「Cookies」檔案或類似技術用於以下目的：</p>
        <p>a. Cashing Pro只利用「Cookies」檔案來鑑定特定期間的使用者，而不會把使用者的敏感性資料存置於「Cookies」檔案內。當使用者瀏覽Cashing Pro網站時，所有聯繫將會利用「Cookies」檔案去識別使用者身份。</p>
        <p>b. 對閣下在網站上的行為進行統計分析，例如瀏覽Cashing Pro網站的次數﹑頁面瀏覽量和每頁上瀏覽時間的長度。這些資料是經集體統計而不記名。</p>
        <p>c. 為了提高用戶體驗，記住閣下在使用Cashing Pro網站時的偏好，讓閣下可以在Cashing Pro網站的公共部分和會員體驗部分輕鬆導航；及</p>
        <p>d. 使用資料當事人曾瀏覽的頁面及打開的網站連結以宣傳個性化的產品：</p>
        <p>・使 Cashing Pro的網站更符合資料當事人的興趣；</p>
        <p>・在 Cashing Pro的網站或第三方網站提供最可能令閣下感興趣的網上廣告；及</p>
        <p>・評估Cashing Pro網上推廣及廣告方案的效率。</p>
        <p className="my-3">以上「Cookies」檔案可能會由Cashing Pro或由代表Cashing Pro的第三方（例如廣告性網絡以及網絡流量分析服務等外部服務的供應商）放置到資料當事人的裝置上。第三方通過使用「Cookies」檔案而被記錄的資料將會經集體統計而不記名，然後與Cashing Pro共享。就「Cookies」檔案的使用，第三方並不會就此向Cashing Pro提供或分享資料當事人的個人聯絡資料。當閣下結束瀏覽Cashing Pro網站時，「Cookies」檔案亦會失效</p>
        <p className="my-3">大部分瀏覽器版本均預設接受「Cookies」檔案。如閣下不希望被這種技術追蹤，閣下可以透過變更網絡瀏覽器的設定而選擇「不接受」「Cookies」檔案。倘若使用者嘗試將其網絡瀏覽器的「Cookies」檔案設定為停止運作，便未必能使用Cashing Pro的網上及其他金融服務。但如閣下不接受所有「Cookies」檔案，包括絕對必要的「Cookies」檔案，閣下可能未能適當地瀏覽Cashing Pro網站或Cashing Pro LiveChat。</p>
        <p className="mt-3">e. 網上改正資料</p>
        <p>透過網上設施提供給Cashing Pro的個人資料一經呈交，便未必能在網上刪除、改正或更新。使用者如未能在網上作出刪除、改正或更新，便應致電2366 8859與Cashing Pro查詢。</p>
        <p className="mt-3">f. 網上保留資料</p>
        <p>在網上收集的個人資料會被轉送到Cashing Pro有關部門處理。個人資料一般不會存置於Cashing Pro網站伺服器的資料庫。</p>
        <p className="mt-3">8. 資料保留</p>
        <p>Cashing Pro的政策，乃採取一切實際可行的步驟以確保個人資料的保存時間不超過將其保存以貫徹該資料被使用於或會被使用於的目的（包括任何直接有關的目的）所需的時間。</p>
        <p className="mt-3">9. 直接促銷</p>
        <p className="mb-3">Cashing Pro及集團公司內的任何機構擬把資料當事人的資料用於貸款服務的直接促銷（作為自願性質），唯該用途未經事前獲得資料當事人的同意（包括對該用途表示不反對），Cashing Pro及集團公司內的任何機構均不得將資料當事人的個人資料用於該用途。就此點，希望客戶留意：</p>
        <p>9.1. Cashing Pro可能不定期將持有的客戶姓名、聯絡資料、貸款産品及服務組合資料、交易模式及行爲、財務背景及人口統計數據等個人資料互相轉移並用於直接促銷；</p>
        <p>9.2. 可用作促銷下列類別的服務、產品及促銷標的：</p>
        <p>9.2.1. 財務相關的服務及產品；及獎賞、客戶忠誠或優惠計劃及相關服務及產品。</p>
        <p className="mb-3">9.3. Cashing Pro希望將資料當事人的個人資料用於直接促銷目的，任何用途的促銷均屬自願性，而根據香港個人資料私隱專員公署對「同意」的定義包括「表示不反對」，若資料當事人不欲本公司將其個人資料用於該用途或希望Cashing Pro知會其他人士停止以其個人資料作該促銷用途，可於辦公時間內告知本公司，就此亦不須付款。</p>
        <p>Cashing Pro資料保障主任</p>
        <p>CASHING PRO LIMITED</p>
        <p>九龍尖沙咀麼地道67號 半島中心11樓1114室</p>
        <p>電郵：feedback@cashingpro.hk</p>
        <p className="mb-3">電話：3155 7600</p>
        <p>Cashing Pro辦公時間</p>
        <p>星期一至五：9:00am–8:00pm (門市營業至7:00pm)</p>
        <p>星期六：9:00am–1:00pm</p>
        <p className="mb-3">星期日及公眾假期休息</p>
        <p className="mb-3">為避免疑問，Cashing Pro不會將第三方的個人資料用於直接營銷目的，除非他們明確同意。</p>
        <p>10. 查閱及更正個人資料</p>
        <p>10.1. 根據及按照《個人資料（私隱）條例》（下稱｢條例｣）中的條款及根據條例發出的 《個人信貸資料實務守則》（下稱｢守則｣），閣下有權：</p>
        <p>a. 查核Cashing Pro是否持有閣下的個人資料及查閱該等資料；</p>
        <p>b. 要求Cashing Pro改正任何有關閣下不準確的個人資料；</p>
        <p>c. 查明Cashing Pro對於個人資料的政策及做法和獲告知Cashing Pro所持有的個人資料種類；</p>
        <p>d. 就客戶的個人信貸而言，閣下可以要求獲告知那些資料會被例行披露予信貸資料服務機構或收數代理，及獲Cashing Pro提供進一步資料，以便向有關信貸資料服務機構或收數代理提出查閱和改正資料的要求；及</p>
        <p>e. 就客戶的個人信貸資料而言，在帳戶全數清還欠款後結束帳戶時，指示Cashing Pro向信貸資料服務機構要求從其資料庫中刪除與該已結束帳戶有關的任何帳戶資料，惟是項指示須於終止戶口後五年內提出，以及無重大拖欠。</p>
        <p>10.2. 如閣下拖欠還款，除非拖欠金額在由出現拖欠日期起計60天屆滿前全數清還或撇賬（破產令除外），否則信貸資料服務機構可保留有關客戶賬戶還款資料，直至自欠款最後清還之日起計滿5年為止；及</p>
        <p>10.3. 如閣下因被頒布破產令而導致任何戶口金額被撇帳，則不論其賬戶還款資料（守則之定義）有否顯示任何重大拖欠（如拖欠還款超過60天的記錄），信貸資料服務機構可保留該賬戶還款資料，直至(i)自欠款最後清還之日起計滿5年為止，或(ii)自客戶提出證據通知信貸資料服務機構其已獲解除破產令之日起計滿5年為止（以較早發生者為準）。</p>
        <p>10.4. 根據條例的條款，Cashing Pro有權就處理任何查閱個人資料的要求收取合理費用。</p>
        <p className="mb-3">10.5. 閣下應將任何有關瀏覽個人資料或更正個人資料的請求，或任何有關Cashing Pro對個人資料的政策和做法的查詢發送至：</p>
        <p>Cashing Pro資料保障主任</p>
        <p>CASHING PRO LIMITED</p>
        <p>九龍尖沙咀麼地道67號 半島中心11樓1114室</p>
        <p className="mb-3">電郵：feedback@cashingpro.hk</p>
        <p className="mb-3">10.6. 本私隱政策及收集個人資料聲明不會限制資料當事人在條例下所享有的權利。</p>
        <p>最後更新︰2022年9月1日</p>
        <div className="flex my-4 items-center justify-center text-center w-full">
          <input type="checkbox" id="id-radio1" checked={isChecked} className="mr-2 w-4 h-4" onChange={(e) => setIsChecked(e.target.checked)} />
          <label htmlFor="id-radio1">
            本人已閱讀並同意以上聲明。
          </label>
        </div>
        <div className="flex justify-center my-4">
          <button
            onClick={() => {
              if (isChecked) {
                navigate('/check-loan-status-stage', {
                  replace: true,
                  state: {
                    requestId: location.state?.requestId,
                    day: location.state?.day,
                    month: location.state?.month,
                    year: location.state?.year,
                  },
                });
              }
            }}
            disabled={!isChecked}
            className={`${isChecked ? 'bg-primary2' : 'bg-mercury'} rounded-full text-white text-xl px-14 py-3`}
          >
            下一步
          </button>
        </div>
      </div>
    </div>
  );
}

export default CheckLoanConsent;
